angular.module('natgeo').factory('SoundEngine', 
function SoundEngine()
{
  var SoundEngine = {};

  // Add all sounds to the engine
  SoundEngine.register = function()
  {
    if (!createjs.Sound.initializeDefaultPlugins()) return;

    createjs.Sound.registerSound('sounds/whip.mp3', 'whip');

    createjs.Sound.registerSound('sounds/menu_transition.mp3', 'menu-transition');
    createjs.Sound.registerSound('sounds/robot_arm_up.mp3', 'menu-select');

    createjs.Sound.registerSound('sounds/fail_bump.mp3', 'fail-bump');
    createjs.Sound.registerSound('sounds/goal_achieved.mp3', 'goal-achieved');

    createjs.Sound.registerSound('sounds/click2.mp3', 'click');
    createjs.Sound.registerSound('sounds/gears-loopit.mp3', 'gear-loopit');
    
    createjs.Sound.registerSound('sounds/gear.mp3', 'gear');
    createjs.Sound.registerSound('sounds/miniRobotTravel.mp3', 'driveby');

    createjs.Sound.registerSound('sounds/show_menu.mp3', 'show-menu');
    createjs.Sound.registerSound('sounds/redeem_passcode.mp3', 'passcode-redeem');
    
    createjs.Sound.registerSound('sounds/conveyor_bad.mp3', 'conveyor-bad');
    createjs.Sound.registerSound('sounds/conveyor_good.mp3', 'conveyor-good');
    createjs.Sound.registerSound('sounds/conveyor_belt_loop.mp3', 'conveyor-belt');
    createjs.Sound.registerSound('sounds/assembly.mp3', 'assembly');
    createjs.Sound.registerSound('sounds/door.mp3', 'door');

    createjs.Sound.registerSound('sounds/robot_move_loop.mp3', 'robot-move');
    createjs.Sound.registerSound('sounds/com_1.mp3', 'com-1');
    createjs.Sound.registerSound('sounds/com_2.mp3', 'com-2');

    createjs.Sound.registerSound('sounds/bee_collision.mp3', 'bee-collision');
    createjs.Sound.registerSound('sounds/bee_fly_loop.mp3', 'bee-fly');
    createjs.Sound.registerSound('sounds/bee_hits_ground.mp3', 'bee-ground');
    createjs.Sound.registerSound('sounds/bird_hit.mp3', 'bird-hit');

    createjs.Sound.registerSound('sounds/ocean_splash_loop.mp3', 'ocean-splash');
    createjs.Sound.registerSound('sounds/ocean_game_loop.mp3', 'ocean');
  };

  // Plays a sounds given an ID an options object.
  // The options object can contain the following properties: delay, offset, loop, pan, startTime, duration
  SoundEngine.play = function(id, options)
  {
    return createjs.Sound.play( id, options || {} );
  };

  // Stops all sounds currently playing
  SoundEngine.stopAll = function()
  {
    createjs.Sound.stop();
  };

  // Mutes all sounds
  SoundEngine.mute = function()
  {
    createjs.Sound.setMute( true );
  };

  // Unmutes all sounds
  SoundEngine.unmute = function()
  {
    createjs.Sound.setMute( false );
  };

  // Returns whether all sounds are muted.
  SoundEngine.isMute = function()
  {
    return createjs.Sound.getMute();
  };

  return SoundEngine;
});